module.exports = __webpack_public_path__ + "img/lantern3.f13e8e41.png";